import React, { useState } from 'react';
import { useTranslation } from 'react-utilities';
import Spinner from './Spinner';

/** Violation images can load very slowly because we do work behind the scenes at request time
 * so we'll want to show a spinner to the user to make it look better. */
const ImageWithSpinner: React.FC<{ url: string; altLabelKey?: string }> = ({
  url,
  altLabelKey
}) => {
  const { translate } = useTranslation();
  const [loading, setLoading] = useState(true);

  /** This should be kept largely in sync with moderation portal. See:
   * Roblox.ModerationPortal.WebApp's ImageWithSpinner.tsx
   * https://github.rbx.com/Roblox/web-frontend/blob/master/WebApps/Roblox.ModerationPortal.WebApp/Roblox.ModerationPortal.WebApp/ts/react/pages/ViolationDetails/ImageWithSpinner.tsx
   * */
  return (
    <React.Fragment>
      <img
        style={loading ? { display: 'none' } : {}}
        className='vd-asset-image'
        src={url}
        alt={altLabelKey && translate(altLabelKey)}
        onLoad={() => setLoading(false)}
        onError={() => setLoading(false)}
      />
      {
        loading && (
          <Spinner size='sm' />
        ) /*
      TODO: [future] This can cause annoying layout shifts, particularly if we have
      content below the image as the spinner is smaller than the image. In the future,
      we could consider using a skeleton for loading or other mechanism to reduce
      layout shifts. (agrossman)
      */
      }
    </React.Fragment>
  );
};

export default ImageWithSpinner;
